module.exports = __webpack_public_path__ + "static/media/img02.6d2000ee.webp";